import React from "react";

const clientToken = import.meta.env.VITE_PAYMENTS_CLIENT_TOKEN as
  | string
  | undefined;

export const PaymentTestModeBanner: React.FC = () => {
  if (!clientToken) {
    return (
      <div className="w-full bg-red-100 border-b border-red-300 px-4 py-2 text-center text-sm text-red-800">
        Production checkout is not configured. Complete Stripe go-live in your
        Lovable project to accept real payments.
      </div>
    );
  }
  if (clientToken.startsWith("pk_test_")) {
    return (
      <div className="w-full bg-orange-100 border-b border-orange-300 px-4 py-2 text-center text-sm text-orange-800">
        Test mode — payments use sandbox cards (e.g.{" "}
        <code className="font-mono">4242 4242 4242 4242</code>). No real money
        moves.
      </div>
    );
  }
  return null;
};

export default PaymentTestModeBanner;
